export default __webpack_public_path__ + "static/media/banner-tablet-bg-orange-template.65c64b27.svg";